export const INCREMENT_SERVED_MEALS_COUNT = 'INCREMENT_SERVED_MEALS_COUNT';
export const MEAL_COUNTER_INCREMENT_PROCESSED_MEAL_COUNTS =
  'MEAL_COUNTER_INCREMENT_PROCESSED_MEAL_COUNTS';
export const MEAL_COUNTER_SELECT_STUDENT = 'MEAL_COUNTER_SELECT_STUDENT';
export const MEAL_COUNTER_RESET = 'MEAL_COUNTER_RESET';
export const MEAL_COUNTER_LOADING = 'MEAL_COUNTER_LOADING';
export const MEAL_COUNTER_ERROR = 'MEAL_COUNTER_ERROR';



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/cepCard/state/types.js